import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.75 8v.266a2.19 2.19 0 0 1 1.62 1.054.74.74 0 0 1-.25 1 .75.75 0 0 1-1-.24.67.67 0 0 0-.59-.36h-.328a.8.8 0 0 1-.202.03.8.8 0 0 1-.202-.03H11.4a.66.66 0 0 0-.16 1.28l1.88.47a2.15 2.15 0 0 1-.37 4.236V16a.76.76 0 0 1-.75.75.76.76 0 0 1-.75-.75v-.266a2.19 2.19 0 0 1-1.62-1.054.75.75 0 1 1 1.28-.78.69.69 0 0 0 .59.35h1.1a.65.65 0 0 0 .51-1.056.66.66 0 0 0-.36-.234l-1.87-.47a2.15 2.15 0 0 1 .37-4.236V8a.75.75 0 1 1 1.5 0" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6.76 20.224A9.75 9.75 0 0 0 12 21.75a9.76 9.76 0 0 0 9.6-11.44 9.751 9.751 0 1 0-14.84 9.914M10.55 3.88A8 8 0 0 1 12 3.75a8.24 8.24 0 0 1 7.524 11.568A8.24 8.24 0 1 1 10.55 3.88",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }